import ToolbarAlignmentMenu from '../components/Toolbar/ToolbarAlignmentMenu';
import ToolbarBlockMenu from '../components/Toolbar/ToolbarBlockMenu';
import ToolbarFormattingMenu from '../components/Toolbar/ToolbarFormattingMenu';
import ToolbarInsertMenu from '../components/Toolbar/ToolbarInsertMenu';
import ToolbarListMenu from '../components/Toolbar/ToolbarListMenu';

const menus = {
  ToolbarAlignmentMenu,
  ToolbarBlockMenu,
  ToolbarFormattingMenu,
  ToolbarListMenu,
  ToolbarInsertMenu,
};

export default menus;
